import type { RazaEventVenueSource } from "@/utils/raza-event-venue-address";

export type RazaEventVenueAddressFieldCopy = {
  label: string;
  helperText: string;
  hallVenueLine: string | null;
};

/** UI copy for the venue address input based on effective venue source. */
export function razaEventVenueAddressFieldCopy(
  source: RazaEventVenueSource,
  hallVenueValue = ""
): RazaEventVenueAddressFieldCopy {
  if (source === "hall") {
    const trimmed = hallVenueValue.trim();
    return {
      label: "Address (override)",
      helperText: "Linked hall venue is used; edit below only if hall link is removed",
      hallVenueLine: trimmed.length > 0 ? `Venue from linked hall: ${trimmed}` : null,
    };
  }

  if (source === "manual") {
    return {
      label: "Address",
      helperText: "Manual venue override — saved with this event",
      hallVenueLine: null,
    };
  }

  if (source === "its") {
    return {
      label: "Address",
      helperText: "Prefilled from host ITS directory — edit to set a manual override",
      hallVenueLine: null,
    };
  }

  return {
    label: "Address",
    helperText: "Venue address; filled from host ITS when available, or enter manually",
    hallVenueLine: null,
  };
}
